import NotFoundPage from 'ha/pages/NotFound';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import getTranslatedCollection from 'ha/utils/urls/getTranslatedCollection';

export default (store, getComponentsWithNotFound) => (nextState, callback) => {
  const collection = nextState.params.localizedKind;

  if (!collection) {
    return callback(null, {
      getComponent: getComponentsWithNotFound('Search'),
    });
  }

  const language = getCurrentLanguageCode(store.getState());
  const translatedCollection = getTranslatedCollection(
    language,
    encodeURIComponent(collection),
  );

  if (translatedCollection) {
    return callback(null, {
      getComponent: getComponentsWithNotFound('Search'),
    });
  }

  return callback(null, {
    component: NotFoundPage,
  });
};
